var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle2, _circle3, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankCautionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 46.0314L19.1813 42.624C19.272 42.3628 19.5265 42.1865 19.8133 42.1863H44.1867C44.4735 42.1865 44.728 42.3628 44.8187 42.624L46 46.0263",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6667 28.1113H43.3334V42.1913H20.6667V28.1113Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3334 46.0314H16.6667",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6694 28.1113V42.1913",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6694 28.1113V42.1913",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3362 28.1113V42.1913",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3362 28.1113V42.1913",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8267 24.7693C45.9271 24.48 45.801 24.163 45.5253 24.0115L32.3307 16.768C32.1244 16.6537 31.8703 16.6537 31.664 16.768L18.464 24.0064C18.1884 24.1578 18.0623 24.4749 18.1627 24.7642L19.1813 27.6736C19.272 27.9348 19.5265 28.1111 19.8133 28.1114H44.1867C44.4735 28.1111 44.728 27.9348 44.8187 27.6736L45.8267 24.7693Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7774 24.2714H18.2161",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 12.5,
    fill: "white",
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 12,
    fill: "#FFAD00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9999 46.5V53.7187",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9999 56.9347C52.0558 56.9347 52.1105 56.9513 52.157 56.9823C52.2034 57.0134 52.2397 57.0575 52.2611 57.1092C52.2825 57.1608 52.2881 57.2176 52.2771 57.2725C52.2662 57.3273 52.2393 57.3777 52.1998 57.4172C52.1603 57.4567 52.1099 57.4836 52.0551 57.4945C52.0002 57.5054 51.9434 57.4998 51.8918 57.4785C51.8401 57.4571 51.796 57.4208 51.7649 57.3744C51.7339 57.3279 51.7173 57.2732 51.7173 57.2173C51.7192 57.143 51.7496 57.0722 51.8022 57.0196C51.8548 56.967 51.9256 56.9366 51.9999 56.9347",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCautionIcon);
export default __webpack_public_path__ + "static/media/bank_caution-icon.9ba1976fba4deb7ccd2993a0ec81a0d0.svg";
export { ForwardRef as ReactComponent };